export default __webpack_public_path__ + "static/media/iara.25882873.png";